<script lang="ts">
	import { gameStart, gameState } from '../../stores/winState';
	import { fade } from 'svelte/transition';
	//import { afterUpdate, onMount } from 'svelte';
	import { SymType } from '../../stores/settingsStore';
	//import { LightenDarkenColor } from '../../utils/colors';
	import BackbgroundStripes from './Components/BackbgroundStripes.svelte';
	//import renderBorder from '../../utils/renderBorder';
	import type { Element, Collection } from 'src/utils/types';
	//import Socket from './Components/socket.svelte';
	//import ElementShadow from './Components/ElementShadow.svelte';
	import { transitionToActive } from '../../stores/gameState';
	//import Joint from './Components/Joint.svelte';

	//export let collection: Collection;
	export let element: Element;

	// export let renderBorder = null;
	// export let mousedown: (index: number) => void = null;
	// export let onmouseout: (hoverState: boolean) => void;
	// export let winState: () => void = null;
	// export let onmouseover: (index1: number, index2: number, x: number, y: number) => void;
	// export let isItemSymemtrical: () => boolean = null;
	// export let changeVariantElement: () => void;
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
{#if $gameStart && $transitionToActive}
	<!-- <BackbgroundStripes color="black" stripWidth={3} /> -->
	<!-- <ElementShadow {element} {collection} symmtery={$SymType} color={'black'} /> -->
	<div
		in:fade={{ delay: 1800 /* * (element.xpos / 200 + element.ypos / 10)*/ }}
		class="item-wrapper"
		style="
        top:{element.ypos >= 5 && $SymType === 'Horizontal'
			? element.ypos * 50 + 2
			: element.ypos * 50}px; 
        left:{element.xpos >= 3 && $SymType === 'Vertical'
			? element.xpos * 50 + 2
			: element.xpos * 50}px;
        "
	>
		<BackbgroundStripes
			stripesCount={15}
			left={-10}
			color="#75c9b7"
			rotate={35}
			spacing={8}
			stripWidth={2}
		/>
		<!-- <div
			class="item"
			style="
	           opacity:{collection.selected ? '1' : '1'};
               {renderBorder(collection, element, LightenDarkenColor('#808080', -100), 4)}
               "
		/> -->

		<!-- <Joint {collection} color={element.color} background="black" />
		<Socket {collection} {element} /> -->
	</div>
{/if}

<style>
	.item-wrapper {
		position: absolute;
		width: 50px;
		height: 50px;
		overflow: hidden;
	}

	/* .item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		background-color: black;
		width: 50px;
		height: 50px;

		z-index: 2;
	} */
</style>
